export default {"src":"/_next/static/media/shield.e9e05c66.svg","height":37,"width":31};